import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"add_buttons"}},[_c(VBtn,{staticStyle:{"float":"right"},attrs:{"icon":"","large":"","color":"blue accent-4"},on:{"click":function($event){return _vm.getChart()}}},[_c(VIcon,[_vm._v("autorenew")])],1)],1),_c('div',{ref:"tree",attrs:{"id":"tree"}})])}
var staticRenderFns = []

export { render, staticRenderFns }